var _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path2, _path3, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecondLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "107px",
    height: "133.4px",
    viewBox: "0 0 107 133.4",
    enableBackground: "new 0 0 107 133.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    transform: "translate(-257.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    fill: "#FFFFFF",
    d: "M364.8,116.1l-11-12.8l0.3-0.1c4.4-1.5,7.7-5.2,7.7-9.8c0-6.1-4.9-11-11-11h-13.5v4.6h13.5 c3.5,0,6.4,2.9,6.4,6.4c0,3.5-3.3,5.9-6.8,5.9h-6.1l14.4,16.9L364.8,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    fill: "#FFFFFF",
    d: "M284.9,82.4l-6,0l-14.3,16.8l14.3,16.9h6l-14.2-16.8L284.9,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    fill: "#FFFFFF",
    d: "M262.2,82.4h-4.4V98l4.4-5.2V82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    fill: "#FFFFFF",
    d: "M262.2,105.5l-4.4-5.2v15.8h4.4V105.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    fill: "#FFFFFF",
    d: "M311.1,116.1L311.1,116.1c0.3,0,0.5,0,0.8,0c7-0.4,12.6-6,13-13c0-0.3,0-1.3,0-1.5V82.4 h-4.5v20.1c-0.1,5.1-4.4,9.2-9.5,9.1c-5-0.1-9-4.1-9.1-9.1V82.4h-4.5v19.2c0,0.3,0,1.2,0,1.5c0.4,7,6,12.6,13,13 C310.6,116.1,310.9,116.1,311.1,116.1L311.1,116.1L311.1,116.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    fill: "#FFFFFF",
    d: "M276.9,127.9h1.8c0.9-0.1,1.6,0.5,1.7,1.4c0,0.1,0,0.1,0,0.2c0,0.7-0.4,1.3-1.1,1.5 l1.3,2.2h-0.7l-1.2-2.2h-1.2v2.2h-0.6L276.9,127.9z M278.8,130.5c0.5,0.1,1-0.3,1.1-0.9c0-0.1,0-0.1,0-0.2c0-0.6-0.4-1-1-1 c0,0-0.1,0-0.1,0h-1.2v2.1L278.8,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    fill: "#FFFFFF",
    d: "M285.6,127.9h3.1v0.6h-2.4v1.8h2.1v0.6h-2.1v1.9h2.5v0.6h-3.1V127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    fill: "#FFFFFF",
    d: "M293.3,131.7h0.6c0,0.7,0.6,1.2,1.2,1.1c0,0,0.1,0,0.1,0c0.7,0,1.2-0.3,1.2-0.9 c0-1.7-3-0.5-3-2.7c0-0.8,0.8-1.5,1.6-1.4c0,0,0.1,0,0.1,0c0.9-0.1,1.7,0.6,1.8,1.4c0,0,0,0.1,0,0.1h-0.6c0-0.6-0.4-1-1.1-1 c-0.8,0-1.1,0.4-1.1,0.9c0,1.5,3,0.4,3,2.6c0,0.8-0.7,1.5-1.9,1.5C294.2,133.4,293.4,132.7,293.3,131.7 C293.3,131.7,293.3,131.7,293.3,131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    fill: "#FFFFFF",
    d: "M302,127.9h3.1v0.6h-2.4v1.8h2.1v0.6h-2.1v1.9h2.5v0.6H302L302,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    fill: "#FFFFFF",
    d: "M311.6,127.9h0.7l2.1,5.4h-0.7l-0.5-1.3h-2.6l-0.5,1.3h-0.7L311.6,127.9z M313.1,131.4 l-1.1-2.8h0l-1.1,2.8H313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    fill: "#FFFFFF",
    d: "M319.2,127.9h1.8c0.9-0.1,1.6,0.5,1.7,1.4c0,0.1,0,0.2,0,0.2c0,0.7-0.4,1.3-1.1,1.5 l1.3,2.2h-0.7l-1.2-2.2h-1.2v2.2h-0.6L319.2,127.9z M321,130.5c0.5,0.1,1-0.3,1.1-0.9c0-0.1,0-0.1,0-0.2c0-0.6-0.4-1-1-1 c0,0-0.1,0-0.1,0h-1.2v2.1L321,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    fill: "#FFFFFF",
    d: "M327.4,130.6c0-1.5,1.1-2.7,2.6-2.8c0,0,0.1,0,0.1,0c1.2,0,2.2,0.7,2.5,1.8H332 c-0.3-0.8-1-1.3-1.9-1.2c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c0.8,0,1.6-0.5,1.8-1.2h0.7c-0.3,1.1-1.4,1.9-2.5,1.8 c-1.5,0-2.7-1.1-2.8-2.6C327.4,130.7,327.4,130.6,327.4,130.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    fill: "#FFFFFF",
    d: "M337.7,127.9h0.6v2.4h2.9v-2.4h0.6v5.4h-0.6v-2.4h-2.9v2.4h-0.6V127.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    fill: "#FFFFFF",
    d: "M51.5,69.4c-0.1-9.4-0.2-24.2-0.2-33.7l0.1,0.2c-4.8-2.8-17.2-10-21.9-12.7l-7.3-4.3 l7.4,4.1c4.6,2.6,17.2,9.8,22,12.6l0.1,0.1v0.1C51.7,45.2,51.7,60,51.5,69.4L51.5,69.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    fill: "#FFFFFF",
    d: "M22.3,18.8c7.6,4.9,16.3,10.4,23.7,15.6c1,0.7,1.9,1.4,2.8,2.2c0.1,0.1,0.3,0.3,0.4,0.4 c0.2,0.7,0.4,1.4,0.4,2.1c1.1,9.7,1.5,20.6,1.9,30.3c-0.7-8.7-1.4-21.8-2.4-30.3c-0.1-0.6-0.2-1.3-0.4-1.9 c-0.2-0.2-0.4-0.4-0.7-0.6C41.1,31.4,29.6,23.9,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    fill: "#FFFFFF",
    d: "M22.3,18.8c4.2,3,8.4,6.2,12.5,9.4c2.1,1.6,4.1,3.2,6.1,4.9c2.1,1.6,4,3.4,5.8,5.4 c1.1,2.4,1.3,5.1,1.9,7.7c0.4,2.6,0.8,5.2,1.2,7.7c0.7,5.2,1.3,10.3,1.8,15.5c-0.7-4.6-1.5-11-2.2-15.5c-0.4-2.6-0.8-5.1-1.3-7.7 c-0.4-2.5-1-5-1.8-7.5c-1.7-1.9-3.6-3.7-5.6-5.3c-2-1.7-4-3.3-6-4.9C31,25.7,25.9,21.7,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    fill: "#FFFFFF",
    d: "M22.3,18.8c5.8,4.9,11.5,10,16.8,15.3c1.9,1.8,3.6,3.7,5.1,5.7c0.7,1.4,1.3,2.9,1.8,4.5 c1,3.3,1.9,6.7,2.6,10.1c1.1,4.9,2.1,9.9,2.9,14.9c-1.9-8-3.6-16-5.9-23.9c-0.2-0.8-0.6-1.9-0.9-2.7c-0.3-0.9-0.7-1.7-1.1-2.5 c-1.5-2-3.1-3.9-4.9-5.6C33.5,29.4,27.6,23.9,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    fill: "#FFFFFF",
    d: "M22.3,18.8c5.2,5.3,10.2,10.8,15,16.5c2.1,2.3,3.9,4.9,5.4,7.7c2.9,6.2,4.9,12.8,6.9,19.3 c0.7,2.4,1.4,4.8,2,7.2c-0.8-2.3-1.6-4.7-2.4-7c-2.1-6.5-4.5-12.8-7.2-19c-1.5-2.7-3.2-5.2-5.2-7.5C32.2,30.3,27,24.3,22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    fill: "#FFFFFF",
    d: "M22.3,18.8c6,7.8,11.8,15.6,17,23.9c4.7,8.6,8.8,17.5,12.2,26.7 c-3.8-7.8-8.8-18.8-13.1-26.2C33.3,35,27.6,27,22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    fill: "#FFFFFF",
    d: "M22.3,18.8c3.5,6.1,7.3,13,10.8,19.1c6,10.5,12.6,20.9,18.4,31.6 c-5.4-8-10.6-16.5-15.7-24.7C30.9,36.4,26.4,27.7,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    fill: "#FFFFFF",
    d: "M22.3,18.8c3.5,9.1,7.1,18.4,12,26.8c3.9,6.2,8.2,12.2,12.7,18c1.5,2,3,3.9,4.5,5.8 c-6.9-7.1-13-14.9-18.3-23.2C28.3,37.7,25,28.3,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    fill: "#FFFFFF",
    d: "M22.3,18.8c2,9.8,4.5,19.6,9.5,28.2c2.6,4.2,5.7,8.2,9,11.9c3.4,3.7,6.9,7.2,10.7,10.5 c-7.5-5.3-14-11.8-19.3-19.3C26,41,23.3,29.7,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    fill: "#FFFFFF",
    d: "M22.3,18.8c0.1,12.8,2.9,26.1,11.5,35.9c3.3,3.9,7.1,7.5,11.2,10.5c2.1,1.6,4.2,3,6.5,4.3 c-10.4-4.6-19.6-12.7-24.9-22.9C22.7,37.9,21.2,28.3,22.3,18.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    fill: "#FFFFFF",
    d: "M22.3,18.8c-1.8,10.4-1,21.8,4.5,31.1c0.7,1,1.5,2.4,2.2,3.3l1.2,1.6 c0.3,0.5,0.9,1.1,1.3,1.5c1.5,1.7,3.2,3.4,5,4.8c4.4,3.6,9.5,6.4,14.9,8.3C39.2,66.7,28.9,58.4,23.6,47 C19.7,38.2,19.5,28,22.3,18.8L22.3,18.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    fill: "#FFFFFF",
    d: "M22.3,18.8c-3.8,10.5-3.9,22.9,2.1,32.5c4.4,7.3,11,12.9,18.9,15.9c2.6,1.1,5.4,1.8,8.2,2.2 c-5.8-0.2-11.5-1.9-16.4-5C27.5,60,21.9,52.7,19.4,44.2C17.3,35.7,18.3,26.7,22.3,18.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    fill: "none",
    stroke: "#A6B2B4",
    strokeWidth: 0.985,
    strokeMiterlimit: 10,
    strokeOpacity: 0,
    d: "M54.7,69.5 V35.7l29.2-16.9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    fill: "#FFFFFF",
    d: "M84,19C75.6,24.6,67.1,30,58.9,36c-0.5,0.3-0.9,0.7-1.3,1.1l-0.1,0.1l-0.1,0.2 c-0.4,2.6-0.7,5.2-0.9,7.7c-0.6,8.1-1.1,16.2-1.6,24.3l-0.4,0c0.5-9.4,1-18.9,1.9-28.3c0.1-1.3,0.3-2.5,0.5-3.8 c0.1-0.3,0.3-0.5,0.5-0.7c0.4-0.3,0.8-0.7,1.2-1c3.8-2.8,7.7-5.5,11.6-8.1c4.5-3,9-6,13.5-9L84,19L84,19z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    fill: "#FFFFFF",
    d: "M84,19c-6.2,4.7-12.4,9.5-18.4,14.5c-2,1.6-3.9,3.4-5.6,5.3c-1,2.3-1.3,5-1.8,7.5 C56.9,54,55.9,61.7,55,69.5l-0.5-0.1c0.6-5.2,1.3-10.4,2-15.5c0.6-3.9,1.1-7.8,1.9-11.6c0.2-1.3,0.6-2.6,1.1-3.8 c0.4-0.6,0.8-1.1,1.3-1.5c3.3-3.2,6.9-6,10.5-8.8c4.1-3.2,8.2-6.4,12.4-9.5L84,19L84,19z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    fill: "#FFFFFF",
    d: "M84.1,19C78,24.5,71.9,30,66.2,36c-1.3,1.3-2.5,2.8-3.6,4.3c-0.6,1.1-1,2.2-1.4,3.4 c-2.6,8.4-4.4,17.2-6.2,25.8l-0.5-0.1c0.5-2.5,1-5,1.5-7.5c1.1-5,2.2-9.9,3.5-14.8c0.6-2.5,1.4-4.9,2.5-7.2 c1.1-1.6,2.3-3.1,3.7-4.4c3.9-4.1,8.1-8,12.3-11.9c1.9-1.7,3.8-3.4,5.7-5.1L84.1,19L84.1,19z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    fill: "#FFFFFF",
    d: "M84.1,19c-3.3,3.7-6.6,7.4-9.8,11.1c-1.6,1.9-3.2,3.8-4.7,5.7c-2,2.3-3.7,4.9-5.2,7.6 c-2.7,6.2-5.1,12.6-7.1,19.1c-0.8,2.4-1.5,4.7-2.3,7.1l-0.5-0.2c0.7-2.4,1.4-4.8,2.1-7.1c1.5-4.7,3-9.5,4.8-14.1 c0.9-2.4,1.9-4.6,3.1-6.8c4.1-6.3,9.2-11.7,14.2-17.3c1.7-1.8,3.4-3.6,5.1-5.5L84.1,19L84.1,19z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    fill: "#FFFFFF",
    d: "M84.1,18.9c-5.5,8-11.3,16-16.3,24.3c-3.6,6.3-6.6,13-9.7,19.7c-1,2.2-2,4.4-3.1,6.7 l-0.5-0.2c0.9-2.3,1.9-4.5,2.9-6.8c2.9-6.8,6.1-13.4,9.6-19.9c2.5-4.2,5.3-8.2,8.1-12.3s5.7-8,8.6-11.9L84.1,18.9L84.1,18.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    fill: "#FFFFFF",
    d: "M84.1,18.9c-4.3,8.6-9,17.5-13.8,25.8c-5,8.2-10.2,16.8-15.4,24.9l-0.4-0.3 c4.8-8.3,10-17,14.9-25.2c4.3-7.3,10.1-18,14.3-25.5L84.1,18.9L84.1,18.9z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    fill: "#FFFFFF",
    d: "M84.1,18.8c-2.7,9.5-6.4,18.7-11.2,27.4c-5.2,8.4-11.2,16.2-18,23.4l-0.3-0.3 c1.6-1.9,3.1-3.8,4.6-5.7c6-7.7,11.9-15.6,16.1-24.5c2.1-4.4,4-8.9,5.8-13.5c0.9-2.3,1.8-4.6,2.6-6.9L84.1,18.8L84.1,18.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    fill: "#FFFFFF",
    d: "M84.1,18.8c-0.8,8.8-3.1,17.5-6.8,25.5c-5,10.3-13.3,18.6-22.4,25.3l-0.2-0.3 c3.8-3.2,7.4-6.7,10.8-10.4c3-3.2,5.6-6.7,8-10.3c2.9-4.8,5.2-9.9,6.8-15.3c1.5-4.8,2.7-9.6,3.5-14.6L84.1,18.8L84.1,18.8z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    fill: "#FFFFFF",
    d: "M84,18.8c1.2,10.5-0.9,21.1-5.9,30.4c-4.1,6.8-9.7,12.5-16.4,16.7c-2.2,1.4-4.5,2.7-6.9,3.7 l-0.1-0.2c2.3-1.2,4.4-2.6,6.5-4.2c13.6-9.9,20.6-21.9,22.3-38.7c0.3-2.6,0.4-5.2,0.3-7.7L84,18.8L84,18.8z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    fill: "#FFFFFF",
    d: "M84,18.8c2.5,7.9,2.5,16.4,0,24.3c-2.5,8-7.6,14.9-14.4,19.8c-4.4,3.2-9.5,5.5-14.9,6.7 l0-0.1c2.6-0.8,5-1.9,7.4-3.2c14.6-7.5,23.5-22.9,22.7-39.4c-0.1-2.7-0.4-5.4-1-8L84,18.8L84,18.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    fill: "#FFFFFF",
    d: "M83.9,18.8c9.5,17.4,1.5,39.9-16.6,47.8c-4,1.8-8.2,2.8-12.6,2.9c2.8-0.4,5.6-1.1,8.2-2.2 C82.5,60,91.6,38,83.9,18.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    fill: "none",
    stroke: "#A5B1B5",
    strokeWidth: 0.985,
    strokeMiterlimit: 10,
    strokeOpacity: 0,
    d: "M82.3,16 L53.1,32.8L23.9,16"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    opacity: 0.091
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    fill: "#FFFFFF",
    d: "M82.4,16.2c-9,4.5-18,9.2-27.3,13.3c-0.5,0.2-0.9,0.4-1.4,0.5c-0.3,0.1-0.6,0.1-0.9,0.1 c-1.2-0.4-2.4-0.9-3.5-1.4c-8.6-3.9-17-8.2-25.4-12.5l0.2-0.4c9,4.5,18,9.1,27.3,13.2c0.5,0.2,1.1,0.4,1.6,0.6c0.1,0,0.3,0,0.4,0 c2.4-0.9,4.8-1.9,7.1-3.1c7.3-3.5,14.5-7.1,21.8-10.7L82.4,16.2L82.4,16.2z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    opacity: 0.182
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    fill: "#FFFFFF",
    d: "M82.4,16.2c-7.2,3.1-14.4,6.1-21.7,8.8c-1.2,0.4-2.5,0.9-3.7,1.3c-1.3,0.5-2.6,0.8-3.9,0.9 c-2.6-0.5-5.1-1.3-7.6-2.3c-2.4-0.9-4.9-1.9-7.3-2.8c-4.8-1.9-9.6-3.9-14.4-6l0.2-0.5c7.2,3,14.4,6,21.7,8.7c2.4,1,4.8,1.7,7.4,2.2 c2.5-0.3,5-1.4,7.4-2.2c7.3-2.7,14.5-5.7,21.7-8.7L82.4,16.2L82.4,16.2z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    opacity: 0.273
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    fill: "#FFFFFF",
    d: "M82.4,16.3c-7.8,2.7-15.6,5.2-23.6,7.2c-1.9,0.5-3.8,0.8-5.7,1c-1.9-0.2-3.8-0.5-5.7-1 c-5.5-1.4-11-3.1-16.4-4.8c-2.4-0.8-4.8-1.6-7.2-2.4l0.2-0.5c8.1,2.6,16.2,5.3,24.5,7.2c1.5,0.4,3,0.6,4.6,0.7 c1.2-0.1,2.5-0.2,3.7-0.5c3.7-0.8,7.3-1.8,11-2.9c4.8-1.4,9.7-3,14.5-4.6L82.4,16.3L82.4,16.3z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    opacity: 0.364
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    fill: "#FFFFFF",
    d: "M82.4,16.3c-7.2,1.8-14.5,3.4-21.8,4.6c-2.5,0.4-4.9,0.7-7.4,0.8c-2.5-0.1-5-0.4-7.4-0.8 c-4.9-0.8-9.7-1.8-14.6-2.9c-2.4-0.5-4.8-1.1-7.2-1.7l0.1-0.5c2.4,0.5,4.8,1,7.3,1.5c4.8,1,9.7,1.9,14.6,2.7 c2.4,0.4,4.9,0.7,7.3,0.8c1.8-0.1,3.7-0.2,5.5-0.5c5.5-0.8,11-1.9,16.4-3c2.4-0.5,4.8-1,7.3-1.5L82.4,16.3L82.4,16.3z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    opacity: 0.455
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    fill: "#FFFFFF",
    d: "M82.3,16.3c-9.7,1.3-19.4,2.2-29.2,2.5c-9.8-0.3-19.5-1.2-29.2-2.5l0.1-0.5 c2.4,0.2,4.9,0.4,7.3,0.6c9.7,0.8,19.4,1.9,29.2,1.1c4.9-0.3,9.7-0.7,14.6-1.1c2.4-0.2,4.9-0.4,7.3-0.7L82.3,16.3L82.3,16.3z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    opacity: 0.545
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    fill: "#FFFFFF",
    d: "M82.3,16.3c-9.5-0.1-19.8-0.3-29.2-0.3s-19.7,0.3-29.2,0.3l0-0.5c17-1,34.1-1.2,51.1-0.4 c2.4,0.1,4.9,0.2,7.3,0.4L82.3,16.3L82.3,16.3z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    opacity: 0.636
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    fill: "#FFFFFF",
    d: "M82.3,16.2c-9.6-1.6-19.4-3.1-29.1-3.1c-7.3,0.2-14.6,0.8-21.9,2c-2.4,0.3-4.8,0.7-7.3,1.1 l-0.1-0.4c2.4-0.6,4.8-1.1,7.2-1.5c7.3-1.4,14.6-2.2,22-2.4c7.4,0.2,14.8,1,22,2.4c2.4,0.5,4.8,0.9,7.2,1.5L82.3,16.2L82.3,16.2z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    opacity: 0.727
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    fill: "#FFFFFF",
    d: "M82.2,16.2c-9.3-3.4-19.2-5.8-29.1-5.9c-7.5,0.2-14.9,1.4-22,3.6c-2.4,0.7-4.8,1.5-7.1,2.3 l-0.1-0.3c4.6-2.1,9.4-3.7,14.3-4.9c4-1,8.1-1.7,12.2-1.9c6-0.3,12,0.4,17.9,1.9c4.9,1.2,9.7,2.9,14.3,4.9L82.2,16.2L82.2,16.2z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    opacity: 0.818
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    fill: "#FFFFFF",
    d: "M82.2,16.1c-8.8-5.3-18.8-8.6-29.1-8.7c-7.7,0.2-15.3,1.9-22.3,5.2c-2.4,1-4.7,2.2-6.9,3.6 l-0.2-0.2C36.5,6.6,53.6,3.1,68.6,8.7c4.9,1.7,9.6,4.1,13.8,7.2L82.2,16.1L82.2,16.1z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    opacity: 0.909
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    fill: "#FFFFFF",
    d: "M82.2,16.1C67.6,2.9,47.2,0.7,30.4,11.3c-2.3,1.4-4.5,3-6.5,4.8L23.9,16 c3.7-4,8.2-7.3,13.2-9.5c11.5-5.2,24.8-4.5,35.7,1.8c3.6,2,6.8,4.6,9.5,7.7L82.2,16.1L82.2,16.1z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    fill: "#FFFFFF",
    d: "M82.3,16C71.6,2.2,52.7-2.2,37,5.5C31.9,8,27.4,11.6,23.9,16c2.3-3.7,5.3-6.9,8.8-9.4 C48.5-5,72.1-0.9,82.3,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondLogo);
export default __webpack_public_path__ + "static/media/secondLogo.0e1a517d9372f1086f4bf42cd8c144a0.svg";
export { ForwardRef as ReactComponent };